import request from '@/utils/request'

// 查询远程教育公益培训-培训公告列表
export function listPxgg(query) {
  return request({
    url: '/web/zlts/pxgg/list',
    method: 'get',
    params: query
  })
}

// 查询远程教育公益培训-培训公告详细
export function getPxgg(recid) {
  return request({
    url: '/web/zlts/pxgg/' + recid,
    method: 'get'
  })
}

// 新增远程教育公益培训-培训公告
export function addPxgg(data) {
  return request({
    url: '/web/zlts/pxgg',
    method: 'post',
    data: data
  })
}

// 修改远程教育公益培训-培训公告
export function updatePxgg(data) {
  return request({
    url: '/web/zlts/pxgg/edit',

    method: 'post',
    data: data
  })
}

// 删除远程教育公益培训-培训公告
export function delPxgg(recid) {
  return request({
    url: '/web/zlts/pxgg/remove/' + recid,

    method: 'post',
  })
}

// 导出远程教育公益培训-培训公告
export function exportPxgg(query) {
  return request({
    url: '/web/zlts/pxgg/export',
    method: 'get',
    params: query
  })
}